export const disableDirectTunnelMessage = {
	AA_DEVICE: (
		<>
			<p>Only UA(Unattended) devices</p>
			<p>can use the Direct Tunnel beta feature.</p>
			<p>Please check the device type.</p>
		</>
	),
	POST_ENABLE_DIRECT_TUNNEL: (
		<>
			<p>
				Please allow up to 4 minutes before configuring Subnet Mappings.
				<br />
				Try to manually refresh the page to see the changes after 4 minutes.
			</p>
			<p>
				Note: Detailed Audit Log is not available in this beta.
			</p>
		</>
	)
}
